import { BUSCAR_EMPRESAS_GESTAO } from '../../actions/types'

const initialState = undefined

export default function reducerEmpresasGestao (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_EMPRESAS_GESTAO: {
      if (action.payload.data) {
        const empresas = action.payload.data.empresas;
        return {
          ...state,
          empresas,
          total: action.payload.data.total
        }
      }
      return state
    }

    default: {
      return state
    }
  }
}
